<template>
  <div class="quartz-edit">
    <el-form class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="rules" label-position="right">
      <!-- 基础信息部分 -->
      <headline title="基本信息" class="headline" />
      <el-divider class="base-divider" />
      <div style="max-width: 434px; padding: 10px 0 5px 20px !important;">
        <el-form-item label-width="94px" label="任务编码：">
          <el-input class="zwx-input" v-model="mainForm.taskCode" disabled />
        </el-form-item>
        <el-form-item label-width="94px" label="任务描述：">
          <el-input class="zwx-textarea" style="width: 300px !important;" type="textarea" v-model="mainForm.taskDescr" disabled />
        </el-form-item>
        <el-form-item label-width="94px" label="接口前缀：">
          <el-input class="zwx-input" v-model="mainForm.apiPrefix" disabled />
        </el-form-item>
        <el-form-item label-width="94px" label="规则表达式：" prop="cron">
          <el-input class="zwx-input" v-model="mainForm.cron" maxlength="50" placeholder="请输入" clearable />
        </el-form-item>
      </div>
    </el-form>
    <el-divider class="base-divider" />
    <!-- 提交部分 -->
    <div style="padding: 12px 20px;">
      <el-button class="zwx-button zwx-button-28" type="primary" @click="$system.valid($refs['mainForm'], '提示', '确定要提交吗？', '确定', '取消', commit)">提交</el-button>
      <el-button class="zwx-button zwx-button-28" @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuartzEdit',
  data() {
    return {
      api: this.$store.state.api,
      users: this.$store.state.users,
      rid: this.$route.params.rid,
      mainForm: {
        taskCode: '',
        taskDescr: '',
        apiPrefix: '',
        cron: '',
      },
      rules: {
        cron: [{ required: true, message: '请输入规则表达式', trigger: ['change', 'blur'] }],
      },
    }
  },
  created() {},
  mounted() {
    this.detail()
  },
  computed: {
    breadcrumbs() {
      return this.$store.state.breadcrumbs
    },
  },
  methods: {
    detail() {
      if (this.rid === undefined) return
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
      }
      this.$system.get(this.api + '/systematic/getQuartz-1', data, true, true, this.detailSuccess, this.detailError)
    },
    detailSuccess(data) {
      if (data.type === '00') {
        this.mainForm.taskCode = data.quartz.taskCode
        this.mainForm.taskDescr = data.quartz.taskDescr
        this.mainForm.apiPrefix = data.quartz.apiPrefix
        this.mainForm.cron = data.quartz.cron
        this.$emit('loading', false)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
        this.back()
      }
    },
    detailError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
      this.back()
    },
    commit() {
      this.$emit('loading', true)
      let data = {
        rid: this.rid,
        cron: this.mainForm.cron,
      }
      this.$system.postJson(this.api + '/systematic/modifyQuartz-1', data, true, true, this.commitSuccess, this.commitError)
    },
    commitSuccess(data) {
      if (data.type === '00') {
        this.$system.notify('成功', data.mess, 'success')
        this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name, params: { fresh: true } })
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.$system.notify('错误', data.mess, 'error')
        this.$emit('loading', false)
      }
    },
    commitError() {
      this.$system.notify('错误', '网络连接失败', 'error')
      this.$emit('loading', false)
    },
    back() {
      this.$router.replace({ name: this.breadcrumbs[this.breadcrumbs.length - 2].name })
    },
  },
}
</script>

<style lang="less" scoped></style>

<style lang="less"></style>
